import { Injectable } from '@angular/core';

export interface ILocalStoreService {
  saveData(key: string, value: any): void;
  retriveData(key: string): any;
}

@Injectable({
  providedIn: 'root'
})
export class LocalstoreService implements ILocalStoreService {

  private store: Storage;
  private readonly appName: string = 'AA_LOCALSTORE';

  constructor() {
    this.store = (typeof window !== 'undefined' && window.hasOwnProperty('localStorage')) ? window.localStorage : null;
  }

  getKey(key: string) {
    return this.appName + '_' + key;
  }

  public saveData(key: string, value: any): void {
    if (this.store) {
        this.store[this.getKey(key)] = value;
    }
  }

  public retriveData(key: string): any {
    if (this.store) {
      return this.store[this.getKey(key)];
    }
  }

}
